import React from 'react';
import ChecklistOptionHeader from 'components/common/headers/ChecklistOptionHeader';
import { useRootStore } from 'store/rootStore';
import { runInAction } from 'mobx';
import { useHistory } from 'react-router-dom';
import { CARD_DATA } from 'global/checklists-helpers/ChecklistHelper';

const RenewalFormHeader = (): JSX.Element => {
  // Common data
  const history = useHistory();

  // Mobx store
  const { webFormStore } = useRootStore();

  async function onSaveChangesAction(): Promise<void> {
    await webFormStore.setAnswers(false);
    runInAction(() => {
      history.goBack();
    });
  }

  return (
    <ChecklistOptionHeader
      onSaveChangesAction={onSaveChangesAction}
      isSaveChangesModal
      title={CARD_DATA.RENEWAL_FORMS.title}
      subtitle={CARD_DATA.RENEWAL_FORMS.text}
    />
  );
};

export default RenewalFormHeader;
